import { TFunction } from 'react-i18next'
import type { TimelineProps } from '@node-space/ui-components'
import { formatOwnerLabel } from 'pages/PaymentLimits/utils'
import { LimitLevel, LimitType, type LimitHistoryEntry } from 'types/paymentLimits'
import { formatNumberWithCommas } from 'utils/utils'

type TimelineVariant = TimelineProps['items'][number]['variant']

export const getEntryVariant = (level: LimitLevel): TimelineVariant => {
  switch (level) {
    case LimitLevel.ALL_CUSTOMERS:
      return 'warning'
    case LimitLevel.ACCOUNT:
      return 'success'
    case LimitLevel.CUSTOMER:
      return 'info'
    default:
      return 'info'
  }
}

export const buildTitle = (entry: LimitHistoryEntry, t: TFunction): string => {
  const ownerLabel = entry.owner ? formatOwnerLabel(entry.owner) : ''
  const limitTypeLabel =
    entry.limitType === LimitType.DAILY
      ? t('paymentLimits.activity.daily')
      : t('paymentLimits.activity.transaction')

  return t('paymentLimits.activity.limitSetAt', {
    owner: ownerLabel,
    limitType: limitTypeLabel,
    amount: `${formatNumberWithCommas(entry.amount)} ${entry.currency}`,
  }).trim()
}

export const buildDescription = (entry: LimitHistoryEntry, t: TFunction): string[] => {
  const lines: string[] = []
  if (entry.updatedBy?.fullName) {
    lines.push(t('paymentLimits.activity.by', { actor: entry.updatedBy.fullName }))
  }
  return lines
}
